import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
// import AddCommunity from "../components/AddCommunity.jsx";
import { db } from "../utils/firebase.jsx";
import { Link } from "react-router-dom";
import "/src/styles/allCommunitiesPage.css";

// Create a form to add a new community to firestore

// This only get documents where "status" is equal to "active" in collection "Communities"

export default function Communities() {
  const comRef = query(
    collection(db, "Communities"),
    where("status", "==", "active")
  );
  if (!comRef) {
    console.error("comRef is undefined");
  }
  const [communities, setCommunities] = useState([]);

  if (!communities) {
    console.error("communities is undefined");
  }

  const [queryState, setQueryState] = useState({
    isLoading: true,
    errorMessage: "",
    docSnapshots: null,
  });
  if (!queryState) {
    console.error("queryState is undefined");
  }

  useEffect(() => {
    async function loader() {
      try {
        setQueryState({
          isLoading: true,
          errorMessage: "",
          docSnapshots: null,
        });
        setQueryState({
          isLoading: false,
          errorMessage: "",
          docSnapshots: communities,
        });
      } catch (error) {
        setQueryState({
          isLoading: false,
          errorMessage: "Error",
          docSnapshots: null,
        });
        console.log(error);
      }
    }

    loader();

    const getCommunities = async () => {
      const communitiesFromServer = await getDocs(comRef);

      let communities = [];
      communitiesFromServer.forEach((doc) => {
        communities.push({ ...doc.data(), id: doc.id });
        setCommunities(communities);
      });
    };
    getCommunities();
  }, []);

  const { isLoading, errorMessage, docSnapshots } = queryState;

  let content;

  if (isLoading) {
    content = (
      <div
        className="spinner-border text-primary text-center justify-center mx-auto flex"
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  } else if (errorMessage) {
    content = errorMessage;
  } else {
    content = (
      <div className="row communityContainer">
        {communities.map((community) => (
          <React.Fragment key={community.id}>
            <div
              // style={{ maxWidth: "400px", margin: "0 auto" }}
              className="individualCommunity "
            >
              <div className="card blog-post border-0 rounded overflow-hidden shadow ">
                <img
                  src={community.img}
                  className="card-img-top"
                  alt={community.name}
                />
                <div className="card-body p-4">
                  <h5 className="mb-3">
                    <Link to={`/${community.slug}`} className="text-dark title">
                      {community.name}
                    </Link>
                  </h5>
                  <p className="text-muted">{community.description}</p>
                  <Link
                    to={`/${community.slug}`}
                    className="text-primary h6 btn btn-primary"
                  >
                    More Info
                    <i data-feather="arrow-right" className="fea icon-sm" />
                  </Link>
                </div>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    );
  }

  return (
    <>
      <section className="section" id="blog">
        <div className="container">
          <div className="row">
            <h1>All Communities</h1>
          </div>

          {content}
        </div>
      </section>
    </>
  );
}
